import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from 'src/app/globals';
import { CRMLogOportunidade } from 'src/app/models/crm/crmlog-oportunidade';

@Injectable({
  providedIn: 'root'
})
export class CrmlogOportunidadeService {

  constructor(private http: HttpClient) { }

  consultarLogsPorOportunidade(idOportunidade, idAtividade) {

    let parametros = new HttpParams().set('idOportunidade', idOportunidade);

    if (idAtividade) {
      parametros = parametros.set('idAtividade', idAtividade);
    }

    return this.http.get<CRMLogOportunidade[]>(globals.apiUrl + '/api/CRMLogOportunidade/ListarPorOportunidade',{
      params: parametros
    });
  }
}
